<script setup lang="ts">
import "./MCheckbox.scss";
import { useFormValue } from "../../../../composables/namedValue";
import { randomID } from "../../../../utils/helpers";
import { computed, ref, useAttrs, watchEffect } from "vue";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  modelValue?: any;
  name?: string;
  label?: string;
}>();

const rawAttrs = useAttrs();
const templateValue = useFormValue(props);
const inputEl = ref<HTMLInputElement>();
const forId = randomID("checkbox");

const isDisabled = computed(() => !!(rawAttrs.disabled || (rawAttrs as any).disable));

watchEffect(() => {
  if (inputEl.value) {
    inputEl.value.indeterminate = templateValue.value == null;
  }
});

const inputAttrs = computed(() => {
  const {
    disabled: _disabled,
    disable: _disable,
    "aria-labelledby": _ariaLabelledby,
    "onUpdate:modelValue": _onUpdate,
    class: _class,
    style: _style,
    ...rest
  } = rawAttrs as any;
  return rest;
});
</script>
<template>
  <label
    class="m-checkbox"
    :class="[rawAttrs.class, { disabled: isDisabled }]"
    :style="(rawAttrs as any).style"
    :for="forId"
  >
    <input
      ref="inputEl"
      :id="forId"
      type="checkbox"
      v-model="templateValue"
      :name="name"
      :disabled="isDisabled"
      class="m-checkbox__native"
      v-bind="inputAttrs"
    />
    <span class="m-checkbox__box" aria-hidden="true">
      <svg class="m-checkbox__svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="m-checkbox__check"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M1.73,12.91 8.1,19.28 22.79,4.59"
        />
        <path class="m-checkbox__indet" fill="currentColor" d="M4,14H20V10H4" />
      </svg>
    </span>
    <slot :id="forId">
      <span class="checkbox-label">{{ label }}</span>
    </slot>
  </label>
</template>
